import type { ReactNode } from 'react';
import {
    CheckBadgeIcon,
    ClockIcon,
    GlobeAltIcon,
    LockOpenIcon,
    Squares2X2Icon
} from '@heroicons/react/24/outline';
import { StatCard } from '../../billing/StatusCards';
import type { RouteStatus } from '../../../services/iam';
import { ROUTE_STATUS_LABEL, ROUTE_STATUS_ORDER } from './routeStatusStyle';

const ICON_CLASS = 'h-3.5 w-3.5';

const STATUS_ICON: Record<RouteStatus, ReactNode> = {
    migrated: <CheckBadgeIcon className={ICON_CLASS} />,
    legacy: <ClockIcon className={ICON_CLASS} />,
    public: <GlobeAltIcon className={ICON_CLASS} />,
    open: <LockOpenIcon className={ICON_CLASS} />
};

const STATUS_UNIT: Record<RouteStatus, string> = {
    migrated: 'requirePermission attached',
    legacy: 'works today, not migrated',
    public: 'deliberately open',
    open: 'no guard at all'
};

interface RouteStatusCardsProps {
    counts: Readonly<Record<RouteStatus, number>>;
    selected: RouteStatus[];
    onChange: (next: RouteStatus[]) => void;
}

// Clickable status stat cards, same pattern as ChargeStatusCards: the cards
// ARE the filter. No special colour for "open" despite being the one real hole.
export function RouteStatusCards({ counts, selected, onChange }: RouteStatusCardsProps) {
    const total = ROUTE_STATUS_ORDER.reduce((sum, status) => sum + (counts[status] ?? 0), 0);

    return (
        <div className="flex items-stretch gap-3 px-8 pt-4">
            <StatCard
                label="All"
                icon={<Squares2X2Icon className={ICON_CLASS} />}
                value={String(total)}
                unit="total routes"
                isActive={selected.length === 0}
                onClick={() => onChange([])}
            />
            {ROUTE_STATUS_ORDER.map((status) => {
                const isActive = selected.length === 1 && selected[0] === status;
                return (
                    <StatCard
                        key={status}
                        label={ROUTE_STATUS_LABEL[status]}
                        icon={STATUS_ICON[status]}
                        value={String(counts[status] ?? 0)}
                        unit={STATUS_UNIT[status]}
                        isActive={isActive}
                        onClick={() => onChange(isActive ? [] : [status])}
                    />
                );
            })}
        </div>
    );
}
